/* Tysk katalog for locale-payroll-delivery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'err.payslip.notAuthorized': 'Du hast keinen Zugriff auf diese Versandanfrage.',
  'err.payslip.approvedRunRequired': 'Genehmige den Lohnlauf, bevor die Lohnabrechnungen in die Warteschlange gestellt werden.',
  'err.payslip.queueTooLarge': 'Die Daten der Lohnabrechnungen sind zu groß für die Warteschlange. Wende dich an den Support.',
  'pay.payslipSent': 'Lohnabrechnung gesendet.',
  'pay.payslipsSent': 'Lohnabrechnungen gesendet.',
  'pay.payslipsSentAndPosted': 'Lohnabrechnungen gesendet und Lohn gebucht.',
  'pay.payslipsQueuedAndPosted': 'Lohn gebucht. Lohnabrechnungen in die Versandwarteschlange gestellt.',
  'pay.payslipQueued': 'In der Versandwarteschlange',
  'pay.payslipsQueued': 'Lohnabrechnungen in der Versandwarteschlange.',
  'pay.payslipGenerated': 'Erstellt',
  'pay.payslipNotReady': 'Nicht bereit',
  'pay.payslipScheduled': 'Geplant',
});
